import { Component } from '@angular/core';

@Component({
  selector: 'app-three-dots-loading',
  template: `
  <div class="dots-container">
    <div class="dot"></div>
  </div>`,
  styleUrls: ['./three-dots-loading.component.scss']
})
export class ThreeDotsLoadingComponent {}
